import { useNavigate } from "react-router-dom";
import {
  RightImage,
  WhyChoose,
  Point1,
  Point2,
  Point3,
  Point4,
  Group,
  OurPromise,
  AI,
  GCC,
  PE,
  DS,
  Maskgroup,
} from "../images/Aboutus";
import { Banner, AboutImage } from "../images/index";
import { useState, useEffect } from "react";
import ScrollToTopButton from "../components/ScrollToTopButton";
import useSlug from "./SlugComp";
import { getPagesBySlug } from "../services/apiService";
import SEO from "./Seo";

const Data = [
  {
    title: "Why Choose Us?",
    bullets: [
      "Proven Transformation Programs",
      "Product Mindset",
      "Agile & Scalable Delivery",
      "Trusted Partnerships",
    ],
    sub: [
      "For commercial and government enterprises",
      "Not just services, but reusable frameworks & accelerators",
      "Delivering innovation at speed with flexibility to scale as your business grows",
      "Empowering clients through integrity, reliability, and results that inspire confidence",
    ],
    img: WhyChoose,
    imgAlt: "Why Choose TechProjects?",
  },
  {
    title: "Built on Trust & Expertise",
    bullets: [
      "20+ Years of Client Success",
      "Trusted by Fortune 500s & Public Sector Agencies",
      "Certified Excellence – MWBE, GSA Schedule 70, ISO 9001:2015, ISO 27001:2013",
      "Hybrid Global Model – U.S. expertise + India delivery centers",
    ],
    img: Maskgroup,
    imgAlt: "Built on Trust & Expertise",
  },
];

const services = [
  {
    icon: (
      <img
        src={AI}
        alt="AI & Automation Labs"
        className="w-10 h-10 mb-4 mx-auto"
      />
    ),
    title: "AI & Automation Labs",
    text: "Innovating with intelligence — transforming operations through smart automation and AI-driven solutions",
  },
  {
    icon: (
      <img
        src={GCC}
        alt="Global Capability Centers (GCCs)"
        className="w-10 h-10 mb-4 mx-auto"
      />
    ),
    title: "Global Capability Centers (GCCs)",
    text: "Setting up innovation hubs & offshore delivery",
  },
  {
    icon: (
      <img
        src={PE}
        alt="Cyber security & Cloud Practices "
        className="w-10 h-10 mb-4 mx-auto"
      />
    ),
    title: "CyberSecurity & Cloud Practices ",
    text: "Building resilient, cloud-enabled enterprises with end-to-end security and innovation at scale.",
  },
  {
    icon: (
      <img
        src={DS}
        alt="Digital Strategy & Transformation"
        className="w-10 h-10 mb-4 mx-auto"
      />
    ),
    title: "Digital Strategy & Transformation",
    text: "Rethinking processes and customer journeys",
  },
];

const bulletImages = [Point1, Point2, Point3, Point4];

function About() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
      console.log(`linked`, data.data);
    };
    fetchData();
  }, []);

  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
            <div className="max-w-lg font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  ABOUT US
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Mission, Vision, Values
              </h1>
              <p className="text-md text-[#404040]">
                To empower global enterprises by delivering intelligent
                technology solutions, building innovation platforms, and
                cultivating high-performance global delivery centers — all while
                fostering a culture of creativity, agility, and long-term value
                creation.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-[6rem]">
              <img src={AboutImage} alt="IT Hiring" className="w-full h-auto" />
            </div>
          </div>
        </div>
        <section className="bg-white py-2 px-6 md:px-12 relative overflow-hidden font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div className="relative flex justify-center md:justify-start">
              <div className="absolute top-8 left-8 w-64 h-72 bg-red-500 rounded-[2rem] -z-10"></div>

              <img
                src={RightImage}
                alt="Team working together"
                className="object-cover"
              />
            </div>

            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                About TechProjects
              </h2>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Empowering Enterprises with Innovation, Intelligence, and Impact
                At TechProjects, we go beyond technology services — we are a
                strategic partner for transformation. With 20+ years of
                experience serving Fortune 500 clients and global enterprises,
                we specialise in GCC, CyberSecurity & Cloud Practices, App
                Development, AI-driven solutions, intelligent automation,
                digital strategy, and platform engineering.
              </p>
            </div>
          </div>
        </section>
        <section className="bg-white py-8 md:py-16 md:px-0 px-6 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto flex flex-col gap-12">
            <div className="flex flex-col md:flex-row justify-between items-center md:items-center md:gap-10">
              <div className="flex-1">
                <h3 className="text-5xl font-semibold text-[#434253] mb-3">
                  {Data[0].title}
                </h3>

                <ul className="space-y-4 font-500 text-xl ml-6 mt-8 text-[#0F172A]">
                  {Data[0].bullets.map((b, i) => (
                    <li key={i} className="flex flex-col items-start gap-1">
                      <div className="flex items-center gap-3">
                        <i
                          className="fa fa-check text-[#F42F39]"
                          aria-hidden="true"
                        ></i>
                        <span>{b}</span>
                      </div>
                      {Data[0].sub && Data[0].sub[i] && (
                        <span className="text-2xl ms-8 font-400 mt-1 text-[#475569]">
                          {Data[0].sub[i]}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex mt-6 md:mt-0">
                <img
                  src={Data[0].img}
                  alt={Data[0].imgAlt}
                  className="w-full object-contain"
                />
              </div>
            </div>

            <div className="mt-12">
              <div className="flex items-center mb-3">
                <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
              </div>
              <h2 className="text-5xl font-extrabold text-[#434253] mb-3">
                Industries We Serve
              </h2>

              <div className="flex flex-col lg:flex-row items-center gap-10">
                <div className="flex-1 flex items-center justify-center">
                  <img
                    src={Group}
                    alt="Industries illustration"
                    className="max-w-md w-full object-contain"
                  />
                </div>

                <div className="flex-1 w-full mb-10">
                  <ul className="space-y-7 text-xl">
                    <li className="flex flex-col items-start">
                      <div className="flex items-center mb-1">
                        <i
                          className="fa fa-check text-[#F42F39] mr-3"
                          aria-hidden="true"
                        ></i>
                        <span className="font-semibold text-[#0F172A] text-xl">
                          Logistics & Supply Chain
                        </span>
                      </div>
                      <div className="ml-7 text-[#475569] font-400 text-2xl">
                        Retail & Wholesale Grocery <br />
                        Predictive analytics, optimization, and automation
                      </div>
                    </li>
                    <li className="flex flex-col items-start">
                      <div className="flex items-center mb-1">
                        <i
                          className="fa fa-check text-[#F42F39] mr-3"
                          aria-hidden="true"
                        ></i>
                        <span className="font-semibold text-[#0F172A] text-xl">
                          Healthcare & Life Sciences
                        </span>
                      </div>
                      <div className="ml-7 text-[#475569] font-400 text-2xl">
                        Secure patient data, analytics, and digital platforms
                      </div>
                    </li>
                    <li className="flex flex-col items-start">
                      <div className="flex items-center mb-1">
                        <i
                          className="fa fa-check text-[#F42F39] mr-3"
                          aria-hidden="true"
                        ></i>
                        <span className="font-semibold text-[#0F172A] text-xl">
                          Financial Services
                        </span>
                      </div>
                      <div className="ml-7 text-[#475569] font-400 text-2xl">
                        AI risk modeling, fraud prevention, customer experience
                      </div>
                    </li>
                    <li className="flex flex-col items-start">
                      <div className="flex items-center mb-1">
                        <i
                          className="fa fa-check text-[#F42F39] mr-3"
                          aria-hidden="true"
                        ></i>
                        <span className="font-semibold text-[#0F172A] text-xl">
                          Government & Public Sector
                        </span>
                      </div>
                      <div className="ml-7 text-[#475569] font-400 text-2xl">
                        CyberSecurity, compliance, modernization
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-[#F3F3F3] py-16 px-4 md:px-20 text-center font-roboto">
          <div className="flex flex-col items-center mb-6">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
            <h2 className="text-7xl font-extrabold text-[#434253] mb-4">
              What We Do
            </h2>
          </div>

          <p className="text-[#404040] font-400 text-lg mb-14">
            We build centers, improve digital systems, and provide talent to
            help businesses work smarter and grow faster.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto mb-12">
            {services.map((s, i) => (
              <div
                key={i}
                className="bg-[#F7F9FC] rounded-2xl p-8 flex flex-col items-center shadow-sm"
              >
                {s.icon}
                <div className="text-xl font-500 text-[#0F172A] mb-3">
                  {s.title}
                </div>
                <div className="text-[#0F172A] font-400 text-lg text-base">
                  {s.text}
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={handleClick}
            type="submit"
            className="bg-activeColor text-white mx-auto text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
          >
            Reach Us
          </button>
        </section>
        <section className="bg-white py-14 px-4 md:px-20 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="flex flex-col md:flex-row-reverse justify-between items-center md:items-start md:gap-10">
              <div className="flex-1 grid gap-5">
                <h3 className="text-5xl font-semibold text-[#434253] mb-3">
                  {Data[1].title}
                </h3>
                <ul className="space-y-8 font-500 text-xl ml-6 mt-8 text-[#0F172A]">
                  {Data[1].bullets.map((b, i) => (
                    <li key={i} className="flex flex-col items-start gap-1">
                      <div className="flex items-start gap-3">
                        <img
                          src={bulletImages[i % bulletImages.length]}
                          alt={`Bullet ${i + 1}`}
                          className="w-5 h-5 object-contain"
                        />
                        <span>{b}</span>
                      </div>
                      {Data[1].sub && Data[1].sub[i] && (
                        <span className="text-2xl ms-8 font-400 mt-1 text-[#475569]">
                          {Data[1].sub[i]}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex mt-6 md:mt-0">
                <img
                  src={Data[1].img}
                  alt={Data[1].imgAlt}
                  className="w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full rotate-[180deg]"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
            <div className="max-w-lg font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-7xl font-extrabold text-[#434253] mb-5">
                Our Promise
              </h2>
              <p className="text-[#404040] text-lg font-400 leading-relaxed">
                We combine the agility of a startup, the depth of enterprise
                experience, and the vision of a product innovator. Our goal is
                not just project delivery, but long-term impact and business
                growth.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-[6rem]">
              <img
                src={OurPromise}
                alt="Mission team working"
                className="w-full max-w-xl object-cover"
              />
            </div>
          </div>
        </div>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default About;
